module.exports = {
  apiKey: '914c1f240d851d967f42eb124ee673e71a9131d3',
  apiUrl: process.env.GATSBY_API_URL || 'http://localhost:3001/api',
  appUrl: process.env.GATSBY_APP_URL || 'https://localhost:3010',
  sentryUrl: 'https://1069016f2014bdcf7196a3f02394e344@o111207.ingest.sentry.io/4505630226382853',
  environment: 'development',
};
